import {EventEmitter, Injectable} from '@angular/core';
import { delay } from '../utils';
import {ShellClientService} from "../shell-communication/shell-client.service";
import {
    GetCurrentQuoteRateShell,
    GetCurrentQuoteRateShellReply,
    GetThrottlingSettingsShell,
    QuoteRateThrottlingSettings, SaveQuoteRateThrottlingSettingsShell
} from "./cqrs-model";

export interface CurrentQuoteRateStatus {
    rate: number;
    throttledRate?: number;
    mode: string;
}

@Injectable()
export class QuoteRateLimiterService {

    constructor(
        private readonly _shellClient: ShellClientService
    ) {
    }

    private _disposed = false;

    currentQuoteRate$ = new EventEmitter<CurrentQuoteRateStatus>();

    start() {
        this._disposed = false;
        this.startPollingQuoteRate().finally(() => {
            console.error('Quote rate limiter polling finished');
        });
    }

    async getThrottlingSettings() : Promise<QuoteRateThrottlingSettings> {
        const qry = new GetThrottlingSettingsShell();
        const result = await this._shellClient.processQuery<QuoteRateThrottlingSettings>(qry);
        return result;
    }

    private async startPollingQuoteRate() {

        while (!this._disposed) {

            await delay(3000);

            let rate = -1;
            let mode = 'N/A';
            let throttledRate = -1;

            const qry = new GetCurrentQuoteRateShell();

            try {
                const result = await this._shellClient
                    .processQuery<GetCurrentQuoteRateShellReply>(qry);
                rate = result.rate;
                mode = result.mode;
                throttledRate = result.throttledRate;
            } catch {
                rate = -1;
            } finally {
                const msg: CurrentQuoteRateStatus = {
                    rate,
                    mode,
                    throttledRate
                }
                this.currentQuoteRate$.emit(msg);
            }
        }
    }

    async saveSettings(settings: QuoteRateThrottlingSettings) {
        const cmd = new SaveQuoteRateThrottlingSettingsShell(settings);
        await this._shellClient.processCommand(cmd)
    }

    stop() {
        this._disposed = true;
    }
}